export default "__VITE_ASSET__BDZMU4iF__"